// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Open+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bg-light {
  background-color: #e9ecef !important;
}

.section-height-75 {
  min-height: 75vh;
}

.page-header {
  padding: 0;
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  background-size: cover;
  background-position: 50%;
}

.card {
  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);
}

.mt-xl-5 {
  margin-top: 3rem !important;
}

.card .card-header {
  padding: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 0px solid rgba(0, 0, 0, .125);

}

.card-header:first-child {
  border-radius: 1rem 1rem 0 0;
}

.text-center {
  text-align: center !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.card .card-body {
  font-family: 'Open Sans', sans-serif;
  /* padding: 1.5rem; */
}

.card-body {
  flex: 1 1 auto;
  padding: 1rem 1rem;
}

label,
.form-label {
  font-size: 0.75rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: #252f40;
  margin-left: 0.25rem;
}

.form-control {
  display: block;
  width: 100%;
  padding: 1rem 0.75rem;
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.4rem;
  color: #333;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  appearance: none;
  border-radius: 0.2rem;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
}

.form-switch {
  padding-left: 3rem;
}

.form-check {
  display: block;
  min-height: 1.5rem;
  padding-left: 1.73em;
  margin-bottom: 0.125rem;
}

.form-switch .form-check-input:checked {
  border-color: rgba(58, 65, 111, 0.95);
  background-color: rgba(58, 65, 111, 0.95);
}

.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: none;
}

.form-check-input:checked[type="checkbox"] {
  background-image: linear-gradient(310deg, #141727 0%, #3A416F 100%);
}

.form-switch .form-check-input {
  border: 1px solid #e9ecef;
  border-top-color: rgb(233, 236, 239);
  border-right-color: rgb(233, 236, 239);
  border-bottom-color: rgb(233, 236, 239);
  border-left-color: rgb(233, 236, 239);
  position: relative;
  background-color: rgba(58, 65, 111, 0.1);
  height: 1.25em;
}

.form-check-label,
.form-check-input[type="checkbox"] {
  cursor: pointer;
}

.form-switch .form-check-input {
  width: 2.5rem;
  margin-left: -3rem;
  background-image: none;
  background-position: left center;
  border-radius: 2.5rem;
  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;
}

.form-check-input:checked {
  background-color: transparent;
  border-color: transparent;
}

.form-check .form-check-input {
  float: left;
  margin-left: -1.73em;
}

.form-check-input {
  appearance: none;
}

a {
  letter-spacing: -0.025rem;
  color: #000;
}

.form-check-input {
  width: 1.23em;
  height: 1.23em;
  margin-top: 0.135em;
  vertical-align: top;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: none;
  appearance: none;
  color-adjust: exact;
  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;
}

.form-check-input {
  color-adjust: exact;
}

.form-switch .form-check-input:checked::after {
  transform: translateX(21px);
}

.form-switch .form-check-input::after {
  transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;
  content: "";
  width: 1rem;
  height: 1rem;
  border-radius: 50%;
  position: absolute;
  background-color: #fff;
  transform: translateX(1px);
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07);
  top: 1px;
}

.text-bold {
  font-weight: 600;
}

.text-decoration-none {
  text-decoration: none !important;
}

.bg-primary {
  background-color: #C22627 !important;
}

.me-xl-5 {
  margin-right: 3rem !important;
}

a:hover {
  color: #830866;
  text-decoration: none;
}

.me-xl-5 {
  margin-right: 3rem !important;
}

.mb-sm-0 {
  margin-bottom: 0 !important;
}

.container,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  max-width: 1320px;
}

.nav-footer .nav-link {
  font-size: .875rem;
}

.h2,
h2 {
  font-size: 1.25rem;
}

.btn-neutral {
  color: #7b2fe3;
}

.table td,
.table th {
  font-size: .8125rem;
  white-space: normal;
}

.pray_text {
  max-width: 450px;
}

.table-flush tbody tr:first-child td,
.table-flush tbody tr:first-child th {
  border-top: 0;
}

.card .table td,
.card .table th {
  padding-right: 1rem;
  padding-left: 1rem;
}

.custom-toggle {
  position: relative;
  display: inherit;
  display: inline-block;
  width: 52px;
  height: 1.5rem;
  margin: 0;
}

.custom-toggle input {
  display: none;
}

input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}

.custom-toggle input:checked+.custom-toggle-slider {
  border: 1px solid #7b2fe3;
}

.custom-toggle-slider {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
  border: 1px solid #ced4da;
  border-radius: 34px !important;
  background-color: transparent;
}

.avatar.rounded-circle img,
.rounded-circle {
  border-radius: 50% !important;
}

.custom-toggle input:checked+.custom-toggle-slider::before {
  transform: translateX(28px);
  background: #7b2fe3;
}

.custom-toggle-slider::before {
  position: absolute;
  bottom: 2px;
  left: 2px;
  width: 18px;
  height: 18px;
  content: '';
  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);
  border-radius: 50% !important;
  background-color: #e9ecef;
}

.custom-toggle input:checked+.custom-toggle-slider::after {
  right: auto;
  left: 0;
  content: attr(data-label-on);
  color: #7b2fe3;
}

.custom-toggle-slider::after {
  font-family: inherit;
  font-size: .75rem;
  font-weight: 600;
  line-height: 24px;
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  overflow: hidden;
  min-width: 1.66667rem;
  margin: 0 .21667rem;
  content: attr(data-label-off);
  transition: all .15s ease;
  text-align: center;
  color: #ced4da;
}

.form-control {
  padding: .6rem .75rem !important;
}

.form-control-label {
  font-size: .875rem;
  font-weight: 600;
  color: #2f3135;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 1.25rem + 2px);
  margin: 0;
  opacity: 0;
}

.custom-file-input {
  width: 60% !important;
  margin: 5px !important;
  opacity: 1 !important;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;
}

.custom-file-label {
  font-weight: 400;
  line-height: 1.5;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  left: 0;
  height: calc(1.5em + 1.25rem + 2px);
  padding: .625rem .75rem;
  color: #8898aa;
  border: 1px solid #dee2e6;
  border-radius: .25rem;
  background-color: #fff;
  box-shadow: 0 3px 2px rgba(233, 236, 239, .05);
}

.custom-file-input:lang(en)~.custom-file-label::after {
  content: 'Browse';
}

.custom-control-label::after {
  top: 0.5rem !important;
}

.custom-file-label::after {
  line-height: 1.5;
  position: absolute;
  z-index: 3;
  top: 0;
  right: 0;
  bottom: 0;
  display: block;
  height: calc(1.5em + 1.25rem);
  padding: .625rem .75rem;
  content: 'Browse';
  color: #8898aa;
  border-left: inherit;
  border-radius: 0 .25rem .25rem 0;
  background-color: #fff;
}

.pagination {
  margin: 15px auto 10px;
  padding-bottom: 2rem;
  justify-content: end;
}

.card-header h3 {
  font-size: 20px;
}

.pagination>.active>a {
  background-color: #C22627;
  border-color: #C22627;
  color: #fff;
}

.pagination>li>a {
  border: 1px solid #C22627;
  padding: 5px 10px;
  outline: none;
  cursor: pointer;
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
  background-color: #C22627;
  border-color: #C22627;
  outline: none;
}

.pagination>li>a,
.pagination>li>span {
  color: #47ccde
}

.pagination>li:first-child>a,
.pagination>li:first-child>span,
.pagination>li:last-child>a,
.pagination>li:last-child>span {
  border-radius: unset
}

.svg-inline--fa.fa-play.fa-w-14 {
  color: #04d611;
}

.loader_block {
  position: fixed;
  display: block;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100% !important;
  z-index: 9999;
  background-color: rgba(255, 255, 255, 0.7);
}

.loader_block span {
  left: 50%;
  top: 50%;
  position: relative;
}

.hide-display {
  display: none;
}

.Toastify__toast {
  padding: 17px !important;
}

.doc_type {
  font-size: large;
  font-weight: bold;
}

.reject {
  color: red;
  font-weight: bold;
}

.approve {
  color: green;
  font-weight: bold;
}

.date-pickk {
  margin-bottom: 10px;
}

.date-pickk input,
.date-pickk>div {
  width: 100% !important;
}

.date-pickk input {
  color: #333;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #d2d6da;
  appearance: none;
  border-radius: 0.2rem;
  padding: .6rem .75rem !important;
}

.display-end {
  display: flex;
  justify-content: end;
}

.select-dropdown {
  width: 100%;
  background: white;
  border: 1px solid #d2d6da;
  padding: .5rem .75rem;
  border-radius: 3px;
  font-size: 0.975rem;
  font-weight: 400;
  line-height: 1.4rem;
  color: #333;
}

.paginate-css {
  display: flex;
  justify-content: end;
}

.pagination>.active>a {
  background-color: #C22627;
  border-color: #C22627;
  color: #fff;
}

.pagination>li>a {
  border: 1px solid #adb5bd;
  padding: 8px 15px;
  outline: none;
  cursor: pointer;
  margin: 3px;
  text-transform: uppercase;
  border-radius: 5px;
}

.pagination>.active>a,
.pagination>.active>span,
.pagination>.active>a:hover,
.pagination>.active>span:hover,
.pagination>.active>a:focus,
.pagination>.active>span:focus {
  background-color: #87bfbb;
  border-color: #87bfbb;
  outline: none;

}

.pagination>li>a,
.pagination>li>span {
  color: #47ccde
}

.pagination>li:first-child>a,
.pagination>li:first-child>span,
.pagination>li:last-child>a,
.pagination>li:last-child>span {
  border-radius: 2px
}

.table-user .name {
  display: block;
  max-width: 150px;
  width: 100px;
}

.td-wrapper {
  background-color: 'lightblue';
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}

.table-user .nameee {
  display: block;
  max-width: 150px;
  width: 150px;

}

.table-user .name2 {
  display: block;
  max-width: 200px;
  width: 170px;
}

.date {
  width: 110px;
  display: block;
}

.date2 {
  width: 70px;
  display: block;
}

.address {
  display: block;
  max-width: 200px;
  width: 170px;
}

.name-letter {
  width: 50px;
  height: 50px;
  border-radius: 30px;
  background-color: #C22627;
  color: #fff;
  justify-content: center;
  align-items: center;
  display: flex;
  font-size: 20px;
}

.address-column {
  width: 250px;
  word-wrap: break-word;
  /* background-color: #04d611; */
}

@media screen and (min-width: 1200px) {
  .large-address-column {
    width: 350px;
    /* background-color: #6200ea; */
  }
}

.mobile-sidebar-slide {
  position: absolute;
  top: 50px;
  left: 0;
  width: 250px;
  height: 100vh;
  background-color: #343a40;
  z-index: 1000;
  animation: slideInLeft 0.3s ease forwards;
  color: white;
  padding: 1rem;
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-100%);
    opacity: 0;
  }

  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

.ql-container.ql-snow {
  border: 1px solid #ccc;
  border-bottom-left-radius: 4px !important;
  border-bottom-right-radius: 4px !important;
}

.ql-toolbar.ql-snow {
  border: 1px solid #ccc;
  box-sizing: border-box;
  font-family: "Helvetica Neue", "Helvetica", "Arial", sans-serif;
  padding: 8px;
  border-top-left-radius: 4px !important;
  border-top-right-radius: 4px !important;
}

.ql-editor p {
  padding-top: 1rem !important;
  font-family: Noto Sans !important;
  font-weight: 400 !important;
  font-size: 15px !important;
  line-height: 24px !important;
  letter-spacing: 0% !important;
  vertical-align: middle !important;
  color: #000000 !important;
}

.no-shadow-table .MuiPaper-root {
  box-shadow: none !important;
}

.Create-template-input {
  height: 40px;
  border-radius: 8px;
  background: transparent !important;
}

.Create-template-input:focus {
  border-style: none !important;
}

input[type="radio"]:checked {
  accent-color: #FF4400;
}




/* .earthwood-user-list .MuiPaper-root {
  background-color: transparent !important;
  box-shadow: none !important;
} */



`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,4CAA4C;;AAE9C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,sCAAsC;EACtC,uCAAuC;EACvC,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,qBAAqB;EACrB,6JAA6J;AAC/J;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EAGE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,6JAA6J;AAC/J;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2EAA2E;EAC3E,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;EAC1B,sHAAsH;EACtH,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;;;EAME,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,WAAW;EACX,wDAAwD;EACxD,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,OAAO;EACP,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,yGAAyG;AAC3G;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,OAAO;EACP,mCAAmC;EACnC,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,QAAQ;EACR,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;;EAEE;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,QAAQ;EACR,OAAO;EACP,WAAW;EACX,uBAAuB;EACvB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;;;;;EAME,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;;AAEf;;AAEA;;EAEE;AACF;;AAEA;;;;EAIE;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;;AAEd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE;IACE,YAAY;IACZ,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,yCAAyC;EACzC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;;EAEA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,+DAA+D;EAC/D,YAAY;EACZ,sCAAsC;EACtC,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;AACvB;;;;;AAKA;;;GAGG","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Open+Sans&display=swap');\n\n\n.bg-light {\n  background-color: #e9ecef !important;\n}\n\n.section-height-75 {\n  min-height: 75vh;\n}\n\n.page-header {\n  padding: 0;\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  background-size: cover;\n  background-position: 50%;\n}\n\n.card {\n  box-shadow: 0 20px 27px 0 rgba(0, 0, 0, 0.05);\n}\n\n.mt-xl-5 {\n  margin-top: 3rem !important;\n}\n\n.card .card-header {\n  padding: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 0px solid rgba(0, 0, 0, .125);\n\n}\n\n.card-header:first-child {\n  border-radius: 1rem 1rem 0 0;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.card .card-body {\n  font-family: 'Open Sans', sans-serif;\n  /* padding: 1.5rem; */\n}\n\n.card-body {\n  flex: 1 1 auto;\n  padding: 1rem 1rem;\n}\n\nlabel,\n.form-label {\n  font-size: 0.75rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  color: #252f40;\n  margin-left: 0.25rem;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: 1rem 0.75rem;\n  font-size: 0.975rem;\n  font-weight: 400;\n  line-height: 1.4rem;\n  color: #333;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #d2d6da;\n  appearance: none;\n  border-radius: 0.2rem;\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.form-switch {\n  padding-left: 3rem;\n}\n\n.form-check {\n  display: block;\n  min-height: 1.5rem;\n  padding-left: 1.73em;\n  margin-bottom: 0.125rem;\n}\n\n.form-switch .form-check-input:checked {\n  border-color: rgba(58, 65, 111, 0.95);\n  background-color: rgba(58, 65, 111, 0.95);\n}\n\n.form-switch .form-check-input:checked {\n  background-position: right center;\n  background-image: none;\n}\n\n.form-check-input:checked[type=\"checkbox\"] {\n  background-image: linear-gradient(310deg, #141727 0%, #3A416F 100%);\n}\n\n.form-switch .form-check-input {\n  border: 1px solid #e9ecef;\n  border-top-color: rgb(233, 236, 239);\n  border-right-color: rgb(233, 236, 239);\n  border-bottom-color: rgb(233, 236, 239);\n  border-left-color: rgb(233, 236, 239);\n  position: relative;\n  background-color: rgba(58, 65, 111, 0.1);\n  height: 1.25em;\n}\n\n.form-check-label,\n.form-check-input[type=\"checkbox\"] {\n  cursor: pointer;\n}\n\n.form-switch .form-check-input {\n  width: 2.5rem;\n  margin-left: -3rem;\n  background-image: none;\n  background-position: left center;\n  border-radius: 2.5rem;\n  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-check-input:checked {\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.form-check .form-check-input {\n  float: left;\n  margin-left: -1.73em;\n}\n\n.form-check-input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n}\n\na {\n  letter-spacing: -0.025rem;\n  color: #000;\n}\n\n.form-check-input {\n  width: 1.23em;\n  height: 1.23em;\n  margin-top: 0.135em;\n  vertical-align: top;\n  background-color: #fff;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: none;\n  appearance: none;\n  color-adjust: exact;\n  transition: background-color 0.25s ease, border-color 0.25s ease, background-position 0.15s ease-in-out, opacity 0.15s ease-out, box-shadow 0.15s ease-in-out;\n}\n\n.form-check-input {\n  color-adjust: exact;\n}\n\n.form-switch .form-check-input:checked::after {\n  transform: translateX(21px);\n}\n\n.form-switch .form-check-input::after {\n  transition: transform 0.25s ease-in-out, background-color 0.25s ease-in-out;\n  content: \"\";\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n  position: absolute;\n  background-color: #fff;\n  transform: translateX(1px);\n  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(20, 20, 20, 0.12), 0 0.125rem 0.25rem -0.0625rem rgba(20, 20, 20, 0.07);\n  top: 1px;\n}\n\n.text-bold {\n  font-weight: 600;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.bg-primary {\n  background-color: #C22627 !important;\n}\n\n.me-xl-5 {\n  margin-right: 3rem !important;\n}\n\na:hover {\n  color: #830866;\n  text-decoration: none;\n}\n\n.me-xl-5 {\n  margin-right: 3rem !important;\n}\n\n.mb-sm-0 {\n  margin-bottom: 0 !important;\n}\n\n.container,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl,\n.container-xxl {\n  max-width: 1320px;\n}\n\n.nav-footer .nav-link {\n  font-size: .875rem;\n}\n\n.h2,\nh2 {\n  font-size: 1.25rem;\n}\n\n.btn-neutral {\n  color: #7b2fe3;\n}\n\n.table td,\n.table th {\n  font-size: .8125rem;\n  white-space: normal;\n}\n\n.pray_text {\n  max-width: 450px;\n}\n\n.table-flush tbody tr:first-child td,\n.table-flush tbody tr:first-child th {\n  border-top: 0;\n}\n\n.card .table td,\n.card .table th {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n.custom-toggle {\n  position: relative;\n  display: inherit;\n  display: inline-block;\n  width: 52px;\n  height: 1.5rem;\n  margin: 0;\n}\n\n.custom-toggle input {\n  display: none;\n}\n\ninput[type=\"checkbox\"],\ninput[type=\"radio\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\n.custom-toggle input:checked+.custom-toggle-slider {\n  border: 1px solid #7b2fe3;\n}\n\n.custom-toggle-slider {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  cursor: pointer;\n  border: 1px solid #ced4da;\n  border-radius: 34px !important;\n  background-color: transparent;\n}\n\n.avatar.rounded-circle img,\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.custom-toggle input:checked+.custom-toggle-slider::before {\n  transform: translateX(28px);\n  background: #7b2fe3;\n}\n\n.custom-toggle-slider::before {\n  position: absolute;\n  bottom: 2px;\n  left: 2px;\n  width: 18px;\n  height: 18px;\n  content: '';\n  transition: all .15s cubic-bezier(.68, -.55, .265, 1.55);\n  border-radius: 50% !important;\n  background-color: #e9ecef;\n}\n\n.custom-toggle input:checked+.custom-toggle-slider::after {\n  right: auto;\n  left: 0;\n  content: attr(data-label-on);\n  color: #7b2fe3;\n}\n\n.custom-toggle-slider::after {\n  font-family: inherit;\n  font-size: .75rem;\n  font-weight: 600;\n  line-height: 24px;\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: block;\n  overflow: hidden;\n  min-width: 1.66667rem;\n  margin: 0 .21667rem;\n  content: attr(data-label-off);\n  transition: all .15s ease;\n  text-align: center;\n  color: #ced4da;\n}\n\n.form-control {\n  padding: .6rem .75rem !important;\n}\n\n.form-control-label {\n  font-size: .875rem;\n  font-weight: 600;\n  color: #2f3135;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.5em + 1.25rem + 2px);\n  margin: 0;\n  opacity: 0;\n}\n\n.custom-file-input {\n  width: 60% !important;\n  margin: 5px !important;\n  opacity: 1 !important;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n}\n\n.custom-file-label {\n  font-weight: 400;\n  line-height: 1.5;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: calc(1.5em + 1.25rem + 2px);\n  padding: .625rem .75rem;\n  color: #8898aa;\n  border: 1px solid #dee2e6;\n  border-radius: .25rem;\n  background-color: #fff;\n  box-shadow: 0 3px 2px rgba(233, 236, 239, .05);\n}\n\n.custom-file-input:lang(en)~.custom-file-label::after {\n  content: 'Browse';\n}\n\n.custom-control-label::after {\n  top: 0.5rem !important;\n}\n\n.custom-file-label::after {\n  line-height: 1.5;\n  position: absolute;\n  z-index: 3;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: block;\n  height: calc(1.5em + 1.25rem);\n  padding: .625rem .75rem;\n  content: 'Browse';\n  color: #8898aa;\n  border-left: inherit;\n  border-radius: 0 .25rem .25rem 0;\n  background-color: #fff;\n}\n\n.pagination {\n  margin: 15px auto 10px;\n  padding-bottom: 2rem;\n  justify-content: end;\n}\n\n.card-header h3 {\n  font-size: 20px;\n}\n\n.pagination>.active>a {\n  background-color: #C22627;\n  border-color: #C22627;\n  color: #fff;\n}\n\n.pagination>li>a {\n  border: 1px solid #C22627;\n  padding: 5px 10px;\n  outline: none;\n  cursor: pointer;\n}\n\n.pagination>.active>a,\n.pagination>.active>span,\n.pagination>.active>a:hover,\n.pagination>.active>span:hover,\n.pagination>.active>a:focus,\n.pagination>.active>span:focus {\n  background-color: #C22627;\n  border-color: #C22627;\n  outline: none;\n}\n\n.pagination>li>a,\n.pagination>li>span {\n  color: #47ccde\n}\n\n.pagination>li:first-child>a,\n.pagination>li:first-child>span,\n.pagination>li:last-child>a,\n.pagination>li:last-child>span {\n  border-radius: unset\n}\n\n.svg-inline--fa.fa-play.fa-w-14 {\n  color: #04d611;\n}\n\n.loader_block {\n  position: fixed;\n  display: block;\n  left: 0%;\n  top: 0%;\n  width: 100%;\n  height: 100% !important;\n  z-index: 9999;\n  background-color: rgba(255, 255, 255, 0.7);\n}\n\n.loader_block span {\n  left: 50%;\n  top: 50%;\n  position: relative;\n}\n\n.hide-display {\n  display: none;\n}\n\n.Toastify__toast {\n  padding: 17px !important;\n}\n\n.doc_type {\n  font-size: large;\n  font-weight: bold;\n}\n\n.reject {\n  color: red;\n  font-weight: bold;\n}\n\n.approve {\n  color: green;\n  font-weight: bold;\n}\n\n.date-pickk {\n  margin-bottom: 10px;\n}\n\n.date-pickk input,\n.date-pickk>div {\n  width: 100% !important;\n}\n\n.date-pickk input {\n  color: #333;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 1px solid #d2d6da;\n  appearance: none;\n  border-radius: 0.2rem;\n  padding: .6rem .75rem !important;\n}\n\n.display-end {\n  display: flex;\n  justify-content: end;\n}\n\n.select-dropdown {\n  width: 100%;\n  background: white;\n  border: 1px solid #d2d6da;\n  padding: .5rem .75rem;\n  border-radius: 3px;\n  font-size: 0.975rem;\n  font-weight: 400;\n  line-height: 1.4rem;\n  color: #333;\n}\n\n.paginate-css {\n  display: flex;\n  justify-content: end;\n}\n\n.pagination>.active>a {\n  background-color: #C22627;\n  border-color: #C22627;\n  color: #fff;\n}\n\n.pagination>li>a {\n  border: 1px solid #adb5bd;\n  padding: 8px 15px;\n  outline: none;\n  cursor: pointer;\n  margin: 3px;\n  text-transform: uppercase;\n  border-radius: 5px;\n}\n\n.pagination>.active>a,\n.pagination>.active>span,\n.pagination>.active>a:hover,\n.pagination>.active>span:hover,\n.pagination>.active>a:focus,\n.pagination>.active>span:focus {\n  background-color: #87bfbb;\n  border-color: #87bfbb;\n  outline: none;\n\n}\n\n.pagination>li>a,\n.pagination>li>span {\n  color: #47ccde\n}\n\n.pagination>li:first-child>a,\n.pagination>li:first-child>span,\n.pagination>li:last-child>a,\n.pagination>li:last-child>span {\n  border-radius: 2px\n}\n\n.table-user .name {\n  display: block;\n  max-width: 150px;\n  width: 100px;\n}\n\n.td-wrapper {\n  background-color: 'lightblue';\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 5px;\n}\n\n.table-user .nameee {\n  display: block;\n  max-width: 150px;\n  width: 150px;\n\n}\n\n.table-user .name2 {\n  display: block;\n  max-width: 200px;\n  width: 170px;\n}\n\n.date {\n  width: 110px;\n  display: block;\n}\n\n.date2 {\n  width: 70px;\n  display: block;\n}\n\n.address {\n  display: block;\n  max-width: 200px;\n  width: 170px;\n}\n\n.name-letter {\n  width: 50px;\n  height: 50px;\n  border-radius: 30px;\n  background-color: #C22627;\n  color: #fff;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  font-size: 20px;\n}\n\n.address-column {\n  width: 250px;\n  word-wrap: break-word;\n  /* background-color: #04d611; */\n}\n\n@media screen and (min-width: 1200px) {\n  .large-address-column {\n    width: 350px;\n    /* background-color: #6200ea; */\n  }\n}\n\n.mobile-sidebar-slide {\n  position: absolute;\n  top: 50px;\n  left: 0;\n  width: 250px;\n  height: 100vh;\n  background-color: #343a40;\n  z-index: 1000;\n  animation: slideInLeft 0.3s ease forwards;\n  color: white;\n  padding: 1rem;\n}\n\n@keyframes slideInLeft {\n  0% {\n    transform: translateX(-100%);\n    opacity: 0;\n  }\n\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n.ql-container.ql-snow {\n  border: 1px solid #ccc;\n  border-bottom-left-radius: 4px !important;\n  border-bottom-right-radius: 4px !important;\n}\n\n.ql-toolbar.ql-snow {\n  border: 1px solid #ccc;\n  box-sizing: border-box;\n  font-family: \"Helvetica Neue\", \"Helvetica\", \"Arial\", sans-serif;\n  padding: 8px;\n  border-top-left-radius: 4px !important;\n  border-top-right-radius: 4px !important;\n}\n\n.ql-editor p {\n  padding-top: 1rem !important;\n  font-family: Noto Sans !important;\n  font-weight: 400 !important;\n  font-size: 15px !important;\n  line-height: 24px !important;\n  letter-spacing: 0% !important;\n  vertical-align: middle !important;\n  color: #000000 !important;\n}\n\n.no-shadow-table .MuiPaper-root {\n  box-shadow: none !important;\n}\n\n.Create-template-input {\n  height: 40px;\n  border-radius: 8px;\n  background: transparent !important;\n}\n\n.Create-template-input:focus {\n  border-style: none !important;\n}\n\ninput[type=\"radio\"]:checked {\n  accent-color: #FF4400;\n}\n\n\n\n\n/* .earthwood-user-list .MuiPaper-root {\n  background-color: transparent !important;\n  box-shadow: none !important;\n} */\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
